<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col cols="12" class="limited-scrollable">
        <CanceledList
          :items="orders"
          :page.sync="page"
          :headers="headers"
          :dataLoaded.sync="dataLoaded"
          :totalItems.sync="totalItems"
          @pageChange="pageChange"  />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CanceledList from '../components/CanceledList';

  export default {
    name: 'Canceled',
    components: {
      CanceledList,
    },
    beforeMount() {
      this.getPageData();
    },
    data: () => ({
      dataLoaded: false,
      page: 1,
      totalItems: 0,
      orders: [],
      headers: [
          { text: 'ID de Orden', value: 'increment_id', align: 'center' },
          { text: 'Nombre de Cliente', value: 'customer_firstname', align: 'center' },
          { text: 'Tipo de Entrega', value: 'shipping_method', align: 'center' },
          { text: 'Fecha de Creación', value: 'created_at', align: 'center' },
      ],
    }),
    methods: {
      getPageData() {
        this.dataLoaded = false;

        this.getDataCall()
          .then((result) => {
            if (result.code == 200) {
              this.orders = result.result.Items;
              this.totalItems = result.result.ItemsSize;
              this.dataLoaded = true;
            } else {
              this.dataLoaded = true;
            }
          })
          .catch(() => {
            this.dataLoaded = true;
          });
      },
      pageChange(value) {
        this.page = value;
        this.getPageData();
      },
      async getDataCall() {
        const params = {
          page: this.page
        };

        return await this.$magentoAxios.get('history/Canceled', params);
      },
    },
  }
</script>

<style scoped></style>